export default __webpack_public_path__ + "static/media/logo-card-1024w.0ca585ad.webp";